import { NavLink, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  SquaresFour, Package, Users, ClipboardText, ChatCircleDots,
  Lightbulb, SignOut, List, X, Wrench, Recycle, Receipt, UsersThree, Storefront, Truck, Wallet,
  ShareNetwork, MapTrifold, Sparkle, ShieldCheck, Briefcase, Bank, Camera, Basket, GraduationCap, Scales, Toolbox, Lifebuoy, Siren, Percent, Envelope, Newspaper, Clock, Buildings, ChartLineUp, Coins, TShirt, ForkKnife, Megaphone, Books, Moon, Drop, Car, House, Plant, BowlFood, LockKey, BookOpen,
} from "@phosphor-icons/react";
import { Avatar } from "@/components/Avatar";
import { useAuth } from "@/context/AuthContext";
import { GlobalSearch } from "@/components/GlobalSearch";
import { Notifications } from "@/components/Notifications";
import { GuidedTip } from "@/components/GuidedTip";
import { MobileTabBar } from "@/components/MobileTabBar";
import { api } from "@/lib/api";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: SquaresFour, testid: "nav-dashboard" },
  { to: "/inventory", label: "Inventory", icon: Package, testid: "nav-inventory" },
  { to: "/warehouse", label: "Virtual Warehouse", icon: Buildings, testid: "nav-warehouse" },
  { to: "/tools", label: "Tool Crib", icon: Wrench, testid: "nav-tools" },
  { to: "/partners", label: "Vendors & Buyers", icon: Users, testid: "nav-partners" },
  { to: "/requests", label: "Supply Requests", icon: ClipboardText, testid: "nav-requests" },
  { to: "/orders", label: "Purchase Orders", icon: Receipt, testid: "nav-orders" },
  { to: "/shipping", label: "Shipping", icon: Truck, testid: "nav-shipping" },
  { to: "/logistics", label: "Logistics", icon: MapTrifold, testid: "nav-logistics" },
  { to: "/freight-time", label: "Freight Time", icon: Clock, testid: "nav-freight-time" },
  { to: "/markets", label: "World Markets", icon: ChartLineUp, testid: "nav-markets" },
  { to: "/commodities", label: "Commodity Prices", icon: Coins, testid: "nav-commodities" },
  { to: "/fashion", label: "Fashion Trends", icon: TShirt, testid: "nav-fashion" },
  { to: "/cafeteria", label: "Cafeteria", icon: ForkKnife, testid: "nav-cafeteria" },
  { to: "/advertising", label: "Advertising", icon: Megaphone, testid: "nav-advertising" },
  { to: "/catalogue-board", label: "Catalogue", icon: Books, testid: "nav-catalogue" },
  { to: "/rest-sleep", label: "Rest & Sleep", icon: Moon, testid: "nav-rest-sleep" },
  { to: "/teamwork-desk", label: "Teamwork", icon: Users, testid: "nav-teamwork" },
  { to: "/pantry-desk", label: "Remote Pantry", icon: Basket, testid: "nav-pantry" },
  { to: "/space-vans", label: "Space & Vans", icon: Package, testid: "nav-space-vans" },
  { to: "/companion", label: "Companion Rides", icon: Car, testid: "nav-companion" },
  { to: "/housing-desk", label: "Living Near Work", icon: House, testid: "nav-housing" },
  { to: "/farmers-desk", label: "Farmers Market", icon: Plant, testid: "nav-farmers" },
  { to: "/fridge", label: "Workplace Fridge", icon: BowlFood, testid: "nav-fridge" },
  { to: "/car-care-desk", label: "Car Care", icon: Car, testid: "nav-car-care" },
  { to: "/price-lock-desk", label: "Price Lock", icon: LockKey, testid: "nav-price-lock" },
  { to: "/english-desk", label: "English Course", icon: BookOpen, testid: "nav-english" },
  { to: "/motels-board", label: "Motels", icon: Buildings, testid: "nav-motels" },
  { to: "/drinks-supplies", label: "Drinks & Supplies", icon: Drop, testid: "nav-refreshments" },
  { to: "/insurance", label: "Insurance", icon: ShieldCheck, testid: "nav-insurance" },
  { to: "/finance", label: "Finance", icon: Bank, testid: "nav-finance" },
  { to: "/privacy", label: "Privacy & Security", icon: ShieldCheck, testid: "nav-privacy" },
  { to: "/ai", label: "AI Assistant", icon: Sparkle, testid: "nav-ai" },
  { to: "/payments", label: "Payments", icon: Wallet, testid: "nav-payments" },
  { to: "/rework-scrap", label: "Rework & Scrap", icon: Recycle, testid: "nav-rework-scrap" },
  { to: "/marketplace", label: "Adverts & Tenders", icon: Storefront, testid: "nav-marketplace" },
  { to: "/stories", label: "Stories & Reels", icon: ShareNetwork, testid: "nav-stories" },
  { to: "/jobs", label: "Jobs & Training", icon: GraduationCap, testid: "nav-jobs" },
  { to: "/advocates", label: "Legal Advisory", icon: Scales, testid: "nav-legal" },
  { to: "/services", label: "Services", icon: Toolbox, testid: "nav-services" },
  { to: "/help", label: "Help & Support", icon: Lifebuoy, testid: "nav-help" },
  { to: "/safety", label: "Safety & Emergency", icon: Siren, testid: "nav-safety" },
  { to: "/tariffs", label: "Tariffs & Duty", icon: Percent, testid: "nav-tariffs" },
  { to: "/parcels", label: "Courier & Post", icon: Envelope, testid: "nav-parcels" },  { to: "/news", label: "Industry News", icon: Newspaper, testid: "nav-news" },
  { to: "/live-feed", label: "Live Feed", icon: Camera, testid: "nav-live-feed" },
  { to: "/network", label: "Network", icon: UsersThree, testid: "nav-network" },
  { to: "/feedback", label: "Feedback", icon: ChatCircleDots, testid: "nav-feedback" },
  { to: "/ideas", label: "Floor Ideas", icon: Lightbulb, testid: "nav-ideas" },
];

export const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [unseen, setUnseen] = useState(0);

  useEffect(() => {
    let stop = false;
    const poll = async () => {
      try {
        const { data } = await api.get("/stories/unseen");
        if (!stop) setUnseen(data.unseen || 0);
      } catch {}
    };
    poll();
    const id = setInterval(poll, 60000);
    return () => {
      stop = true;
      clearInterval(id);
    };
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  const makeSidebar = (idPrefix) => (
    <div className="flex h-full flex-col bg-[#0F172A] text-slate-300">
      <div className="flex items-center gap-2.5 border-b border-white/10 px-5 py-5">
        <div className="flex h-8 w-8 items-center justify-center bg-[#002FA7]">
          <Wrench size={18} weight="bold" className="text-white" />
        </div>
        <div className="leading-tight">
          <div className="font-display text-sm font-extrabold tracking-tight text-white">
            UNITY &amp; UTILITY
          </div>
          <div className="overline text-[0.6rem] text-slate-500">Floor Operations</div>
        </div>
      </div>

      <nav className="flex-1 space-y-0.5 overflow-y-auto p-3">
        {NAV.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`${idPrefix}${testid}`}
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-3 text-sm transition-colors duration-150 sm:py-2.5 ${
                isActive
                  ? "bg-[#002FA7] text-white font-semibold"
                  : "hover:bg-white/5 hover:text-white"
              }`
            }
          >
            <Icon size={18} />
            {label}
            {to === "/stories" && unseen > 0 && (
              <span
                data-testid={`${idPrefix}stories-unseen-badge`}
                className="ml-auto flex h-5 min-w-5 items-center justify-center bg-[#FF3B30] px-1.5 text-[0.65rem] font-bold text-white"
              >
                {unseen}
              </span>
            )}
          </NavLink>
        ))}
        {(user?.role === "lender" || user?.role === "scheme_officer" || user?.role === "admin") && (
          <NavLink
            to="/finance-desk"
            data-testid={`${idPrefix}nav-finance-desk`}
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-3 text-sm transition-colors duration-150 sm:py-2.5 ${
                isActive ? "bg-[#002FA7] text-white font-semibold" : "hover:bg-white/5 hover:text-white"
              }`
            }
          >
            <Bank size={18} />
            Finance Desk
          </NavLink>
        )}
        {(user?.role === "agent" || user?.role === "admin") && (
          <NavLink
            to="/agent-desk"
            data-testid={`${idPrefix}nav-agent-desk`}
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-3 text-sm transition-colors duration-150 sm:py-2.5 ${
                isActive ? "bg-[#002FA7] text-white font-semibold" : "hover:bg-white/5 hover:text-white"
              }`
            }
          >
            <Briefcase size={18} />
            Agent Desk
          </NavLink>
        )}
        {user?.role === "admin" && (
          <NavLink
            to="/members"
            data-testid={`${idPrefix}nav-members`}
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-3 text-sm transition-colors duration-150 sm:py-2.5 ${
                isActive ? "bg-[#002FA7] text-white font-semibold" : "hover:bg-white/5 hover:text-white"
              }`
            }
          >
            <Users size={18} />
            Members
          </NavLink>
        )}
      </nav>

      <div className="border-t border-white/10 p-4">
        <NavLink
          to="/profile"
          data-testid={`${idPrefix}sidebar-user`}
          className="mb-3 flex items-center gap-2.5 transition-opacity duration-150 hover:opacity-80"
        >
          <Avatar imageId={user?.avatar_id} name={user?.name} size="sm" testid={`${idPrefix}sidebar-avatar`} />
          <div className="min-w-0">
            <div className="truncate text-sm font-semibold text-white">{user?.name}</div>
            <div className="overline text-[0.6rem] text-[#7FA0FF]">{user?.role}</div>
          </div>
        </NavLink>
        <button
          data-testid={`${idPrefix}logout-button`}
          onClick={handleLogout}
          className="flex w-full items-center gap-2 border border-white/15 px-3 py-2 text-sm transition-colors duration-150 hover:bg-white/10 hover:text-white"
        >
          <SignOut size={16} /> Sign out
        </button>
      </div>
    </div>
  );

  return (
    <div className="flex min-h-screen bg-[#F8FAFC]">
      <aside className="hidden w-64 shrink-0 lg:block">
        <div className="fixed h-screen w-64">{makeSidebar("")}</div>
      </aside>

      {open && (
        <div className="fixed inset-0 z-50 lg:hidden" data-testid="mobile-drawer">
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm animate-in fade-in-0"
            onClick={() => setOpen(false)}
          />
          <div className="absolute left-0 top-0 h-full w-[82%] max-w-xs shadow-2xl animate-in slide-in-from-left duration-200">
            <button
              data-testid="close-drawer-button"
              onClick={() => setOpen(false)}
              aria-label="Close menu"
              className="absolute right-3 top-4 z-10 flex h-9 w-9 items-center justify-center text-slate-400 hover:text-white"
            >
              <X size={20} />
            </button>
            {makeSidebar("drawer-")}
          </div>
        </div>
      )}

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="sticky top-0 z-40 flex items-center gap-3 border-b border-border bg-white/95 px-4 py-3 backdrop-blur lg:hidden">
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(true)}
            aria-label="Open menu"
            className="-ml-1 flex h-10 w-10 items-center justify-center"
          >
            <List size={22} />
          </button>
          <span className="font-display truncate text-sm font-extrabold tracking-tight">
            UNITY &amp; UTILITY
          </span>
          <span className="overline ml-auto shrink-0 text-[0.6rem] text-[#002FA7]">{user?.role}</span>
        </header>
        <main id="main-content" className="flex-1 p-4 pb-24 sm:p-6 lg:p-8 lg:pb-8">
          <div className="mb-4 flex items-center justify-end gap-2 lg:mb-6">
            <GlobalSearch />
            <Notifications />
          </div>
          <GuidedTip />
          {children}
        </main>
        <MobileTabBar onMenu={() => setOpen(true)} />
      </div>
    </div>
  );
};
